import { FC } from 'react';
import { ListItem, OrderedList } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { ShineStartNextStepsProps } from './types';

const ShineStartNextStepsList: FC<ShineStartNextStepsProps> = ({
  orderedSteps,
}) => (
  <OrderedList>
    {orderedSteps.map((stepText) => (
      <ListItem key={stepText} paddingLeft="space-4">
        <Text>{stepText}</Text>
      </ListItem>
    ))}
  </OrderedList>
);

export default ShineStartNextStepsList;
